import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { req } from '../utils';

const NotesDialog = ({ open, onClose, accountId, venueId, type="venue" }) => {
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (open) {
      setLoading(true);
      req("get", "get_account_notes", { id: accountId||venueId, type: type })
          .then((response) => {
              // Handle the notes data from response
              setNotes(response);
          })
          .catch((error) => {
              console.error("Error fetching notes:", error);
          })
          .finally(() => {
              setLoading(false);
          });
    }
  }, [open, accountId, venueId, type]);

  const handleSave = () => {
    if (!newNote.trim()) {
      toast.error('Please enter a note');
      return;
    }
    setLoading(true);
    req('post', 'add_note', { note: newNote, venue_id: venueId, type: type })
      .then(() => {
        toast.success('Note added successfully');
        setNotes(prevNotes => [{
          note_id: Date.now(),
          created_time: Math.floor(Date.now() / 1000),
          created_by_name: 'You',
          note: newNote
        }, ...prevNotes]);
        setNewNote('');
        onClose();
      })
      .catch((error) => {
        toast.error('Failed to add note: ' + (error.message || 'Unknown error'));
      })
      .finally(() => setLoading(false));
  };

  // Filter notes based on search
  const filteredNotes = notes?.length ? notes.filter(note => 
    note.note.toLowerCase().includes(searchTerm.toLowerCase()) ||
    note.created_by_name.toLowerCase().includes(searchTerm.toLowerCase())
  ) : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Account Notes</DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <CircularProgress />
          </div>
        ) : notes.length > 0 ? (
          <>
            {/* Search Bar 
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search notes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
*/}
            {/* Notes Display */}
            <div style={{ 
              maxHeight: '400px', 
              overflowY: 'auto',
              marginBottom: '20px'
            }}>
              {filteredNotes.map((note) => (
                <div key={note.note_id} style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                  <Typography variant="body2" color="textSecondary">
                    {format(new Date(Number(note.created_time) * 1000), 'PPpp')} - {note.created_by_name}
                  </Typography>
                  <Typography variant="body1" style={{ marginTop: '4px' }}>
                    {note.note}
                  </Typography>
                </div>
              ))}
            </div>
          </>
        ) : (
          <Typography variant="body1" align="center" sx={{ py: 3 }}>
            No notes yet
          </Typography>
        )}

        {/* New Note Input */}
        <TextField
          multiline
          rows={4}
          fullWidth
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder="Enter new note..."
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={loading} color="persiangreen">
          Add note
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesDialog;
